module.exports = __webpack_public_path__ + "40dfb0a98b6bf807bc19f0eb50fb272e.pdf";